<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import Vuex from 'vuex'

export default {
  data: function () {
    return {
      treeData: global.tree_attributes,
      treeIndex: global.tree_index,
      newItems: []
    }
  }
}
</script>
<style>
</style>
